import { useContext, useEffect, useState } from "react";
import { DataContext } from "../DataContext";
import MapViewSwitch from "./MapVIewSwitch";
import $data from "../../services/$data";
import Map from "./Map";
import { AppContext } from "../../AppContext";

function MapWrapper(props) {
	const { user, onUpdateState } = useContext(AppContext);
	const { projectData, onUpdateProjectData, onUpdateMapData, onGetParcels } = useContext(DataContext);
	// const [loading, setLoading] = useState({
	// 	parcels: !Boolean(projectData[props.project]?.parcels),
	// 	datesS2: !Boolean(projectData[props.project]?.parcels),
	// })

	const [loading, setLoading] = useState({
		parcels: true,
		photos: true,
		samples: true
	})

	const [view, setView] = useState('applicability');

	const [datesState, setDatesState] = useState({
		dates: [],
		timeM: null
	})

	useEffect(() => {
		onUpdateState({selected: parseInt(props.project)})

		if (user.user_type === 1) {
			getPhotos();

			getSamples();

			getParcels();

			// getDatesS2();
		} else {
			//SET PARCELS AS ARRAY IF NOT EXIST - OTHERWISE SET LOADING TO FALSE
			if (!Boolean(projectData[props.project]?.parcels)) {
				onUpdateProjectData(props.project, { parcels: [] });
			} else {
				setLoading((state) => ({ ...state, parcels: false }));
			}

			getParcels();

			// getDatesS2();

			// getFarms();

			getPhotos();

			getSamples();
		}

	}, []);


	const getParcels = async () => {
		try {
			await onGetParcels(props.project);
		} catch (e) {

		} finally {
			setLoading((loadingState) => ({ ...loadingState, parcels: false }));
		}
	}


	const getPhotos = async () => {
		try {
			let photos = await $data.getPhotos(props.project);
			onUpdateProjectData(props.project, { ...projectData[props.project], photos });
		} catch (e) {

		} finally {
			setLoading((loadingState) => ({ ...loadingState, photos: false }));
		}
	}

	const getSamples = async () => {
		try {
			let samples = await $data.getSamples(props.project);
			
			onUpdateProjectData(props.project, { ...projectData[props.project], samples });
		} catch (e) {

		} finally {
			setLoading((loadingState) => ({ ...loadingState, samples: false }));
		}
	}


	return (
		<div style={{ height: '100%', position: 'relative' }} className="co-background-secondary-opacity fade-in">
			<Map projectId={props.project} view={view} data={projectData[props.project]} dates={datesState.dates} timeM={datesState.timeM} onSetDatesState={setDatesState} loading={loading.parcels  || loading.photos || loading.samples} />
			{/* <MapViewSwitch view={view} onSetView={setView} /> */}

		</div>
	)
}

export default MapWrapper;